// extracted by mini-css-extract-plugin
export default {"root":"Page_root__urWvS","document":"Page_document__1gIWx","title":"Page_title__08KOk","active":"Page_active__XOvkt"};